// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "178bf413d58f10392322c5d332b1da73b88748c4/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};